import React from 'react';
import ConnectRentalAccount from './ConnectRentalAccount';

export default function CustomerWelcome({ user, onConnected, logout }) {
  return <div className="tg-dash"><main className="tg-onboarding">
    <header className="tg-welcome-header">
      <div><div className="tg-brand"><span className="tg-brand-mark">T</span> Tegrat Auto</div>
        <h1>Welcome{user.firstName ? `, ${user.firstName}` : ''}</h1>
        <p>You’re signed in. No rental account is linked yet.</p></div>
      <button type="button" className="tg-btn" onClick={logout}>Sign out</button>
    </header>
    <div className="tg-onboarding-grid">
      <ConnectRentalAccount onConnected={onConnected} />
      <div className="tg-onboarding-new">
        <section className="tg-card tg-card-pad">
          <div className="tg-card-title"><h2>New to Tegrat?</h2></div>
          <p>You don’t need an existing rental to keep your login. If an agent has already set up your customer record, link it using the phone number they have on file. Otherwise, contact a rental office to get started.</p>
          <a className="tg-btn" href="https://tegratauto.com/support">Contact a rental office</a>
        </section>
      </div>
    </div>
  </main></div>;
}
